import { Component } from '@angular/core';
import { WindowRef } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ca-result-share',
    templateUrl: './result-share.component.html',
    styleUrls: ['./result-share.component.scss'],
})
export class ResultShareComponent {
    shareLink: string = '';
    shareText: string = 'Check out my result I created on arivis Cloud.';

    constructor(
        private activeModal: NgbActiveModal,
        private windowRef: WindowRef,
    ) {}

    dismiss(reason?: string): void {
        this.activeModal.dismiss(reason);
    }

    openTwitter(): void {
        const twitterLink: string = `https://twitter.com/share?text=${this.shareText}&url=${encodeURIComponent(this.shareLink)}&hashtags=Apeer`;
        const w = this.windowRef.nativeWindow.open(twitterLink, '_blank', 'width=800,height=500');
        if (w != null) {
            w.focus();
        }
    }

    openEmail(): void {
        this.windowRef.nativeWindow.location.href = `mailto:?body=${this.shareText}%0D%0A${this.shareLink}`;
    }

    openLinkedIn(): void {
        const link: string = `https://www.linkedin.com/shareArticle?mini=true&summary=${encodeURIComponent(this.shareText)}%0D%0A${encodeURIComponent(
            this.shareLink,
        )}`;
        const w = this.windowRef.nativeWindow.open(link, '_blank', 'width=1200,height=700');
        if (w != null) {
            w.focus();
        }
    }
}
